module.exports = __webpack_public_path__ + "static/media/finland_logo.a3556210.png";